import { create } from 'zustand'
import { LibraryCollection } from '@/models.ts'
import useGlobalStore from '@/useGlobalStore.ts'

export enum OnSuccessfulFinalActionMode {
	ADD = 'add',
	EDIT = 'edit',
	DELETE = 'delete',
}

export type SuccessfulFinalActionCallback = (mode?: OnSuccessfulFinalActionMode, item?: LibraryCollection) => void

interface ModalState {
	isOpen: boolean
	mode: string // saved or add
	setMode: (mode: string) => void
	data: LibraryCollection | null
	setData: (data: LibraryCollection) => void
	onSuccessfulFinalAction: SuccessfulFinalActionCallback | null
	setOnSuccessfulFinalAction: (onSuccessfulFinalAction: SuccessfulFinalActionCallback) => void
	onCollectionAdded: (() => void) | null
	setOnCollectionAdded: (onCollectionAdded: () => void) => void
	showModal: () => void
	hideModal: () => void
}

const useCollectionDetailsModalStore = create<ModalState>((set) => ({
	isOpen: false,
	mode: 'saved',
	setMode: (mode: string) => set({ mode }),
	data: null,
	setData: (data: LibraryCollection) => set({ data }),
	onSuccessfulFinalAction: null,
	setOnSuccessfulFinalAction: (onSuccessfulFinalAction: () => void) => set({ onSuccessfulFinalAction }),
	onCollectionAdded: null,
	setOnCollectionAdded: (onCollectionAdded: () => void) => set({ onCollectionAdded }),
	showModal: () => {
		const globalStore = useGlobalStore.getState
		globalStore().setIsModalVisible(true)
		set({
			isOpen: true,
		})
	},
	hideModal: () => {
		const globalStore = useGlobalStore.getState
		globalStore().setIsModalVisible(false)
		set({
			data: null,
			isOpen: false,
			onSuccessfulFinalAction: null,
			onCollectionAdded: null,
		})
	},
}))

export default useCollectionDetailsModalStore
